import * as React from 'react';
export const creditdunordSvg = React.forwardRef(function creditdunordSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#3A9BD9',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.5 4 15 17H9l5 2.5-2 5.5 4.5-3.83L22 28l-3-8.5 5-2.5h-6L16.5 4Z',
      fill: '#fff',
    }),
  );
});
creditdunordSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var creditdunord = {
  category: 'brand',
  colorable: false,
  name: 'creditdunord',
  svg: creditdunordSvg,
};
